import AgenciaObjetivoImportPage from "./AgenciaObjetivoImportPage";

export {AgenciaObjetivoImportPage}
export default AgenciaObjetivoImportPage
